import React  from "react";
import { graphql } from "gatsby";
import Portofolio from "./templates/portfolio";
import About from "./templates/about";
import DefaultTemplate from "./templates/default";


const App = ({location, data}: any) => {
  if (data.mdx.frontmatter.type) {
    switch(data.mdx.frontmatter.type) { 
      case 'portfolio': { 
        return (<Portofolio location={location} data={data} />);
        break; 
      }
      case 'about': { 
        return (<About location={location} data={data} />);
        break; 
      } 
      default: {
        
        break; 
      } 
    }
  }
 return (<DefaultTemplate location={location} data={data} />);
 //   return (<Template location={location} data={data} />);

}

export default App;

/*

*/
//(formatString: "MMMM DD, YYYY")
export const pageQuery = graphql`
  query($slug: String! ) {
    mdx(frontmatter: { slug: { eq: $slug } }) {
      body
      tableOfContents
      headings {
        depth
        value
      }
      frontmatter {
        date
        lastmod
        public
        slug
        title
        description
        keywords
        type
        priority
        years
        image
        colors { 
          bg
          text
        }
      }
    }
  }
`;
//lang changefreq